import { Panel, Typography } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PickedCampaignInterface } from '@/store/campaigns/types';
import dayjs from '@/services/tools/dayjs';
import { TIME_RANGE_0_MINUTES, TIME_RANGE_60_MINUTES, MINUTES_IN_DAY } from '@/services/constants';
import useMobile from '@/services/hooks/useMobile';
import { StyledProps } from '@/components/Campaigns/CampaignsInterface';

const TriggerInlineValue = styled.div<StyledProps>`
    display: flex;
    flex-direction: row;
    align-items: ${({ isMobile }): string => !isMobile && 'center'};
`;

export const TriggerText = (props: { pickedCampaign: PickedCampaignInterface }): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const { pickedCampaign } = props;

    const getTriggerBy = (): string => {
        const triggerChannelName = pickedCampaign?.campaign?.TriggerOptions?.TriggeredBy?.ChannelName;
        const triggerChannelData = pickedCampaign?.campaign?.TriggerOptions?.TriggeredBy?.Data;

        if (triggerChannelName) {
            const channelName = triggerChannelName ? `"${triggerChannelName}"` : t('anycampaignlower');
            const channelData = triggerChannelData ? `${t('andspecificlinkcontains')} ${triggerChannelData}` : '';
            return `${t('fromlower')} ${channelName} ${channelData}`;
        } else {
            return '';
        }
    };

    const getTriggerText = (): string => {
        switch (pickedCampaign?.campaign?.TriggerOptions?.Type) {
            case 'OnAdd':
                return t('contactaddedtoaudience');
            case 'OnOpen':
                return t('contactfromaudienceopens');
            case 'OnClick':
                return t('contactfromaudienceclicks');
            default:
                break;
        }
    };

    const getTriggerMinutes = (): string => {
        const sendAfter = pickedCampaign?.campaign?.TriggerOptions?.SendAfterXMinutes;
        const sendEvery = pickedCampaign?.campaign?.TriggerOptions?.SendEveryXMinutes;

        if (sendAfter > TIME_RANGE_0_MINUTES) {
            if (sendAfter < TIME_RANGE_60_MINUTES) {
                return `${sendAfter} ${t('minutesafter')}`;
            } else if (sendAfter < MINUTES_IN_DAY) {
                return `${dayjs.duration({ minutes: sendAfter }).asHours()} ${t('hoursafterafter')}`;
            } else {
                return `${dayjs.duration({ minutes: sendAfter }).asDays()} ${t('daysafter')}`;
            }
        } else if (sendEvery > TIME_RANGE_0_MINUTES) {
            if (sendEvery < TIME_RANGE_60_MINUTES) {
                return `${t('everyCaptalize')} ${sendEvery} ${t('minutes')}`;
            } else if (sendEvery < MINUTES_IN_DAY) {
                return `${t('everyCaptalize')} ${dayjs.duration({ minutes: sendEvery }).asHours()} ${t('hours')}`;
            } else {
                return `${t('everyCaptalize')} ${dayjs.duration({ minutes: sendEvery }).asDays()} ${t('days')}`;
            }
        } else {
            return t('immediatelywhen');
        }
    };
    const panelProps = isMobile && { ...{ headerPadding: '32px' } };

    return (
        <div style={{ marginBottom: isMobile ? '46px' : '64px' }}>
            <Panel
                description={
                    <TriggerInlineValue isMobile={isMobile}>
                        <div style={{ marginRight: '32px', width: isMobile && '85px' }}>
                            <Typography variant="body2">{t('triggerevent')}</Typography>
                        </div>
                        <div style={{ maxWidth: isMobile && '50%' }}>
                            <Typography variant="h4">
                                {getTriggerMinutes()} {getTriggerText()} {getTriggerBy()}
                            </Typography>
                        </div>
                    </TriggerInlineValue>
                }
                {...panelProps}
            />
        </div>
    );
};
